import { render, staticRenderFns } from "./configList.vue?vue&type=template&id=0c89d0d2&scoped=true"
import script from "./configList.vue?vue&type=script&lang=js"
export * from "./configList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c89d0d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c89d0d2')) {
      api.createRecord('0c89d0d2', component.options)
    } else {
      api.reload('0c89d0d2', component.options)
    }
    module.hot.accept("./configList.vue?vue&type=template&id=0c89d0d2&scoped=true", function () {
      api.rerender('0c89d0d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/devconfig/configList.vue"
export default component.exports